import Grid from '@material-ui/core/Grid';
import EndAdornmentResetButton from './EndAdornmentResetButton';
import EndAdornmentUpdateButton from './EndAdornmentUpdateButton';

const EndAdornment = () => {
  return (
    <Grid container wrap="nowrap">
      <Grid item>
        <EndAdornmentResetButton />
      </Grid>
      <Grid item>
        <EndAdornmentUpdateButton />
      </Grid>
    </Grid>
  );
};

export default EndAdornment;
